var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack393({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.87,11.16V5.57H5.45a2.89,2.89,0,0,1,.89.11A1.61,1.61,0,0,1,7,6.16a2.55,2.55,0,0,1,.46.9,4.36,4.36,0,0,1,.16,1.27,4,4,0,0,1-.28,1.61,1.92,1.92,0,0,1-.71.94,2,2,0,0,1-1.14.28Zm.6-.66h1a1.76,1.76,0,0,0,.89-.19,1.27,1.27,0,0,0,.47-.62A3.91,3.91,0,0,0,7,8.33,3.26,3.26,0,0,0,6.8,7a1.28,1.28,0,0,0-.6-.65,2.05,2.05,0,0,0-.77-.11h-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.49,11.16V5.57h2a2.18,2.18,0,0,1,.94.16,1.2,1.2,0,0,1,.5.52,1.74,1.74,0,0,1,.19.84,1.55,1.55,0,0,1-.33,1,1.56,1.56,0,0,1-1,.5,1.24,1.24,0,0,1,.38.31,4,4,0,0,1,.48.71l.8,1.52h-.76L11.16,10a7.46,7.46,0,0,0-.54-.92.93.93,0,0,0-.35-.32,1.17,1.17,0,0,0-.47-.08H9.1v2.48ZM9.1,8h1.3a1.77,1.77,0,0,0,.65-.1.79.79,0,0,0,.35-.33,1,1,0,0,0,.13-.51.88.88,0,0,0-.25-.67,1,1,0,0,0-.73-.24H9.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack393);
export default __webpack_public_path__ + "static/media/Symbol_pack_393.f201e04d8745f5d1e8ca64d9635b954e.svg";
export { ForwardRef as ReactComponent };